import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { config } from '../config/config'

export const whiteLabelApi = createApi({
  reducerPath: 'whiteLabelApi',
  tagTypes: ['WhiteLabelLogo'],
  baseQuery: fetchBaseQuery({
    baseUrl: `${config.apiURL}/`,
    credentials: config.apiCredentials
  }),
  endpoints: builder => ({
    getWhiteLabelColor: builder.query({
      query: ({ clientId, type }) => `${type}/white-labeling/${clientId}`
    }),
    getWhiteLabelLogo: builder.query({
      query: ({ clientId, type }) => ({
        url: `${type}/white-labeling/${clientId}/logo`,
        headers: { Accept: 'image/svg+xml' },
        responseHandler: response => response.text()
      }),
      providesTags: (result, _error, { clientId }) =>
        result ? [{ type: 'WhiteLabelLogo', id: clientId }] : [],
      keepUnusedDataFor: 60 * 60
    })
  })
})

export const { useGetWhiteLabelColorQuery, useGetWhiteLabelLogoQuery } =
  whiteLabelApi
